const formatRelativeLocale = {
  lastWeek: "'siku ya mwisho' eeee 'saa' p",
  yesterday: "'jana saa' p",
  today: "'leo saa' p",
  tomorrow: "'kesho saa' p",
  nextWeek: "eeee 'saa' p",
  other: 'P',
};

export default function formatRelative(token, date, baseDate, options) {
  return formatRelativeLocale[token];
}
